import { clusterStylesFactory } from "./ClusterStyle";
import { getFilteredLocations, filterAndSortDealerListByDistance} from "./DistributorsList";
import {convertDistributorToFeature, debounce, replaceLast} from "./helper";
import {
  DistributionData,
  DistributorsList,
  Feature,
  FeatureWithDistance,
  keyboardEvent,
  LngLat,
} from "./DistributorsMap.types";


declare const OverlappingMarkerSpiderfier: any;
declare const SuperClusterAdapterLoader: any;

export const DistributorsMap = () => {
  const divFordistributorslist: HTMLElement = document.querySelector(
    `.comp-distributorsmap--list`
  );
  const distributorslistResults: HTMLElement = document.querySelector(
    `.comp-distributorsmap--list-results`
  );

  const inputForListFilterField: HTMLInputElement = <HTMLInputElement>(
    document.querySelector(`.comp-distributorsmap--input-list`)
  );

  const divForMap: HTMLElement = document.querySelector(
    `.comp-distributorsmap--map`
  );

  const divForMapSearch: HTMLElement = document.querySelector(
    `.comp-distributorsmap--input-map-wrapper`
  );

  const inputForMapSearchField: HTMLInputElement = <HTMLInputElement>(
    document.querySelector(`.comp-distributorsmap--input-map`)
  );

  const FormForMapSearch: HTMLFormElement = <HTMLFormElement>(
    document.querySelector(`.comp-distributorsmap-form-map`)
  );

  const buttonForCard: HTMLElement = document.querySelector(
    `.comp-distributorsmap--btn-card`
  );
  const buttonForList: HTMLElement = document.querySelector(
    `.comp-distributorsmap--btn-list`
  );
  const divForLoader: HTMLElement = document.querySelector(
    `.comp-distributorsmap--loader`
  );
  const inputWrapperForMapSearchField: HTMLElement = document.querySelector(
    `.comp-distributorsmap--input-map-wrapper`
  );
  const divForLegend: HTMLElement = document.querySelector(
    `.comp-distributorsmap--legend`
  );

  let map: google.maps.Map;
  let infoWindow: google.maps.InfoWindow;

  const assetsPath = divForMap.dataset.assetsPath;


  const initMap = async () => {
    const apiUrl = divForMap.dataset.apiUrl;
    const countryCode: string = divForMap.dataset.countrycode;
    let startZoom = 6;
    const formForMapSearchField =
      inputWrapperForMapSearchField.querySelector<HTMLFormElement>("form");
    const divForMapSearchFieldTopBar =
      inputWrapperForMapSearchField.querySelector<HTMLFormElement>("div");

    const divForMapSearchFieldToggle =
      divForMapSearchFieldTopBar.querySelector<HTMLFormElement>(
        ".comp-distributorsmap--input-map-toggle"
      );
    const buttonElement =
      formForMapSearchField.querySelector<HTMLFormElement>("button");
    const divForSearchbar =
      divFordistributorslist.querySelector<HTMLFormElement>(
        ".comp-distributorsmap--searchbar"
      );

    const convertedJsonToFeature = (data: DistributionData[]): Feature[] => data.map(convertDistributorToFeature);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const distributors = await response.json();
    const convertedJson: Feature[] = convertedJsonToFeature(distributors.locations);
    const mapStartCenterPosition = distributors.center;
    startZoom = distributors.zoom;

    const distributorsList: DistributorsList = {
      type: "FeatureCollection",
      features: convertedJson,
    };


    map = new google.maps.Map(divForMap, {
      zoom: startZoom,
      center: mapStartCenterPosition,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: true,
    });

    function getMapCenter(): LngLat {
      return [map.getCenter().lng(), map.getCenter().lat()];
    }

    map.addListener(
      'center_changed',
      debounce(async () => await updateDealerListFromSearchTermAndMapCenter())
    );

    // Create the search box and link it to the UI element.
    const options = {
      fields: ["address_components", "geometry"],
    };

    // Specify just the place data fields that you need.
    const autocomplete = new google.maps.places.Autocomplete(
      inputForMapSearchField,
      options
    );

    autocomplete.setComponentRestrictions({
      country: [countryCode],
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.geometry || !place.geometry.location) {
        return;
      }

      if (place.geometry) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(15);
      }
    });

    const oms = new OverlappingMarkerSpiderfier(map, {
      markersWontMove: true,
      markersWontHide: true,
      basicFormatEvents: true,
      ignoreMapClick: true,
      keepSpiderfied: true,
    });
    google.maps.event.addListenerOnce(map, "mousemove", async () => {
      // initialize the dealer list on first interaction with the map
      await updateDealerListFromSearchTermAndMapCenter();
    });
    google.maps.event.addListenerOnce(map, "tilesloaded", async () => {
      SuperClusterAdapterLoader.getClusterer().then(async (Clusterer: any) => {
        if (Clusterer) {
          const distributors = distributorsList;
          if (distributors) divForLoader.style.display = "none";
          const onMarkerClick = (marker: google.maps.Marker) => {
            infoWindow.close();
            const id = marker.get("id");
            const info = distributors.features[id].properties.info;
            const content = `<div>${info}</div>`;
            infoWindow.setContent(content);
            infoWindow.open(map, marker);
          };

          const clusterer = new Clusterer.Builder(map)
            .withRadius(90)
            .withMaxZoom(19)
            .withMinZoom(0)
            .withCustomMarkerIcon(customMarkerIcon)
            .withMarkerClick(onMarkerClick)
            .withOverlapMarkerSpiderfier(oms)
            .withStyles(clusterStylesFactory(assetsPath))
            .build();

          clusterer.load(distributors);
        }
      });
    });

    infoWindow = new google.maps.InfoWindow();

    const toggleCardList = () => {
      // buttonForCard und buttonForList sind redundant und müssen zu einer Funktion umgeschrieben werden.
      // Möglicherweise wäre es besser das Toggeln mit SASS zu lösen
      // List
      let buttonForCardClass = buttonForCard.getAttribute("class");
      let buttonForListClass = buttonForList.getAttribute("class");
      const isCardactivated = buttonForCardClass.search(" btn--secondary-white") <= 0;
      if (!isCardactivated) {
        buttonForCardClass = replaceLast(
          buttonForCardClass,
          " btn--secondary-white",
          " btn--primary"
        );
        buttonForListClass = replaceLast(
          buttonForListClass,
          " btn--primary",
          " btn--secondary-white"
        );
        divForMap.style.display = "block";
        divForMapSearch.style.display = "block";
        divForLegend.style.display = "block";
        divFordistributorslist.style.display = "none";
        // activate Map-Search
        inputWrapperForMapSearchField.classList.remove("is--active");
      } else {
        // Map
        buttonForListClass = replaceLast(
          buttonForListClass,
          " btn--secondary-white",
          " btn--primary"
        );
        buttonForCardClass = replaceLast(
          buttonForCardClass,
          " btn--primary",
          " btn--secondary-white"
        );
        divForLegend.style.display = "none";
        divForMap.style.display = "none";
        divForMapSearch.style.display = "none";
        //comp-distributorsmap--legend
        divFordistributorslist.style.display = "block";
      }
      buttonForCard.setAttribute("class", buttonForCardClass);
      buttonForList.setAttribute("class", buttonForListClass);
    };

    buttonForCard.addEventListener("click", function (event) {
      event.preventDefault();
      toggleCardList();
    });

    buttonForList.addEventListener("click", function (event) {
      event.preventDefault();
      toggleCardList();
    });

    FormForMapSearch.addEventListener("submit", function () {
      inputWrapperForMapSearchField.classList.add("is--active");
    });

    //
    // Distributors Map
    //

    const chooseFirstFromResults = () => {
      const isMobile = window.innerWidth <= 768;
      const step1 = new Event("keydown") as keyboardEvent;
      step1.keyCode = 40;
      google.maps.event.trigger(inputForMapSearchField, "keydown", step1);

      const step2 = new Event("keydown") as keyboardEvent;
      step1.keyCode = 13;
      step1.triggered = true;
      google.maps.event.trigger(inputForMapSearchField, "keydown", step2);

      const focusOutEvent = new Event("blur");
      inputForMapSearchField.dispatchEvent(focusOutEvent);
      inputForMapSearchField.blur();
      // If device is mobile (Phone or Tablet) hide search mask
      if (isMobile) {
        inputWrapperForMapSearchField.classList.add("is--active");
      }
    };

    divForMapSearchFieldToggle.addEventListener("click", function (event) {
      event.preventDefault();
      inputWrapperForMapSearchField.classList.toggle('is--active');
    });

    buttonElement.addEventListener("click", function (event) {
      event.preventDefault();
      chooseFirstFromResults();
    });

    //
    // Distributors List
    //

    const updateDealerListFromSearchTermAndMapCenter = async () => {
      const dealersInCloseDistance = filterAndSortDealerListByDistance(getMapCenter(), convertedJson);
      const filteredDealersInCloseDistance = getFilteredLocations(inputForListFilterField.value, dealersInCloseDistance);
      createDistributorsListHTML(filteredDealersInCloseDistance);
    };

    inputForListFilterField.addEventListener(
      "keydown",
      debounce(async () => await updateDealerListFromSearchTermAndMapCenter(), 100)
    );

    // catch clicks on "show on map" links
    distributorslistResults.addEventListener("click", (event) => {
      const target = event.target as HTMLElement;
      if (!target.classList.contains('comp-distributorsmap--link-to-map')) {
        return;
      }

      event.preventDefault();
      const isMobile = window.innerWidth <= 768;
      const lat = +target.dataset.lat;
      const lng = +target.dataset.lng;
      toggleCardList();
      map.panTo({ lat, lng });
      map.setZoom(17);
      if (isMobile) {
        inputWrapperForMapSearchField.classList.add("is--active");
      }
    });

    const createDistributorsListHTML = (filteredDistributorList: FeatureWithDistance[]) => {
      function distanceToString(distance: number) {
        if (distance < 1.0) {
          return '< 1';
        }
        if (distance < 10) {
          return (Math.round(distance * 10) / 10).toLocaleString('de-DE');
        }
        return Math.round(distance).toString();
      }

      distributorslistResults.innerHTML = filteredDistributorList.map(
          ([distanceInKm, distributor]) => {
            return [
              `<div class="comp-distributorsmap--distributer">`,
              `  <p>${distanceToString(distanceInKm)} km entfernt</p>`,
              `  <div class="comp-distributorsmap--distributer-infos">`,
              `    ${distributor.properties.info}`,
              `  </div>`,
              `  <div class="comp-distributorsmap--link-to-map-container">`,
              `    <a class="comp-distributorsmap--link-to-map" data-lat="${distributor.geometry.coordinates[1]}" data-lng="${distributor.geometry.coordinates[0]}">Auf der Karte anzeigen</a>`,
              `  </div>`,
              `</div>`
            ].join("\n");
          }
        )
        .join("\n");
    };
  };

  const customMarkerIcon = (feature: Feature) => {
    if (
      feature.properties.icon ===
      "/bikeleasing-service/website/google-maps/standard.png"
    ) {
      return `${assetsPath}/Images/DistributorsMap/standard.png`;
    } else {
      return `${assetsPath}/Images/DistributorsMap/premium.png`;
    }
  };

  initMap();
};

declare global {
  interface Window {
    DistributorsMap: () => void;
  }
}

// Register globally to be callable by Google Maps API
// @see ext/sitepackage/Resources/Private/Components/Organism/DistributorsMap/DistributorsMap.html:4
window.DistributorsMap = () => {
  DistributorsMap();
};
